module.exports = __webpack_public_path__ + "img/0Q3A5746_L_Black_MockedUp.624eed49.jpg";